import { plain } from "./RichText";
import { ContentPage, waLink } from "./ContentPage";
import { SITE_URL } from "@/lib/seo";
import type { ProcedureContent } from "@/content/inner-pages";

export function ProcedurePage({ data }: { data: ProcedureContent }) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "MedicalProcedure",
        name: data.name,
        description: data.metaDescription,
        url: `${SITE_URL}${data.path}`,
        procedureType: "https://schema.org/SurgicalProcedure",
        bodyLocation: data.tags.join(", "),
        performer: {
          "@type": "Physician",
          name: "Dr. Kelson Kawamura",
          medicalSpecialty: "PlasticSurgery",
          url: `${SITE_URL}/dr-kelson-kawamura`,
        },
      },
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Início", item: `${SITE_URL}/` },
          { "@type": "ListItem", position: 2, name: "Especialidades", item: `${SITE_URL}/especialidades` },
          { "@type": "ListItem", position: 3, name: data.name, item: `${SITE_URL}${data.path}` },
        ],
      },
      {
        "@type": "FAQPage",
        mainEntity: data.faq.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: plain(f.a) },
        })),
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <ContentPage
        eyebrow="Cirurgia plástica · Foz do Iguaçu"
        h1={data.h1}
        heroTitle={data.heroTitle}
        lead={data.lead}
        image={data.image}
        imageAlt={`${data.name} — Dr. Kelson Kawamura, cirurgião plástico em Foz do Iguaçu`}
        crumbs={[{ label: "Especialidades", to: "/especialidades" }, { label: data.name }]}
        blocks={data.blocks}
        related={data.related}
        articles={data.articles}
        relatedTitle="Procedimentos relacionados"
        faq={data.faq}
        ctaLabel="Agendar avaliação"
        ctaHref={waLink(`Olá! Gostaria de agendar uma avaliação sobre ${data.name} com o Dr. Kelson Kawamura.`)}
        ctaSecondary={{ label: "Conhecer o consultório", href: "/consultorio-cirurgia-plastica-foz-do-iguacu" }}
      />
    </>
  );
}
